import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser, clearError, clearSuccessMessage, clearErrors } from '../../store/slices/authSlice';
import banner from '../../assets/img/pexels-earano-1683802.jpg'
import Logo from '../../components/Logo'
import Input from '../../components/fields/Input'
import Checkbox from '../../components/fields/Checkbox'
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue'
import { ErrorMessage } from '../../components/messages/success';
import Dialog from '../../components/common/Dialog';
import GuestHeader from '../../layout/GuestHeader'
import Footer from '../../layout/Footer';
import {Helmet} from "react-helmet";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isRegistering, error, errors, user, token, successMessage } = useSelector((state) => state.auth);
  const [showDialog, setShowDialog] = useState(false);
  
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    mobile_number: '',
    password: '',
    password_confirmation: '',
    terms: false,
  });

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (user !== null && successMessage && successMessage === 'success') {
      dispatch(clearSuccessMessage());
      navigate('/verify');
    }
  }, [user, successMessage, navigate, dispatch]);

  useEffect(() => {
      dispatch(clearError());
      dispatch(clearErrors());
      dispatch(clearSuccessMessage());
    }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.password_confirmation) {
      setShowDialog(true);
      return;
    }
    dispatch(registerUser(formData));
  };

  const renderErrorMessages = () => {
    return Object.entries(errors).map(([field, messages]) => (
      <ErrorMessage key={field} message={`${messages.join(', ')}`} />
    ));
  }

  return (
    <>
      <Helmet>
          <title>Sign Up | Oreca Pro</title>
          <link rel="canonical" href={window.location.href} />
      </Helmet>
      <GuestHeader />
      <Dialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        title="Password Mismatch"
      >
        <p className="text-custom-light-grey mb-6">Passwords do not match</p>
        <div className="flex justify-end">
          <button
            onClick={() => setShowDialog(false)}
            className="px-4 py-2 rounded-md bg-custom-charcoal text-white hover:bg-custom-charcoal/80 transition-colors"
          >
            Close
          </button>
        </div>
      </Dialog>
      <section
        style={{ backgroundImage: `url(${banner})` }}
        className='guest-section relative min-h-[100vh] bg-center bg-cover pb-[100px]'
      >
        <div 
          className='absolute inset-0'
          style={{
            background: 'linear-gradient(180deg,rgba(16, 28, 34, 0) 0%, rgba(16, 28, 34, 0.15) 46%, rgba(16, 28, 34, 0.84) 55%, rgba(16, 28, 34, 1) 64%)'
          }}
        />
        <div className='w-full max-w-[340px] relative mx-auto text-center px-4 pt-[120px] md:pt-[160px]'>
          <div className='scale-[1.4] my-5'>
            <Logo />
          </div>
          <h1 className='text-3xl font-semibold my-5'>Sign Up</h1>
          <p className='mt-5 mb-7 font-normal'>Enter your details to get started with orca, your personalized surf forecast</p>

          <form onSubmit={handleSubmit}>
            {error && <ErrorMessage message="Registration failed" />}
            {renderErrorMessages()}
              <Input
                type="text"
                id="firstname"
                name="firstname"
                value={formData.firstname}
                onChange={handleInputChange}
                required
                placeholder="First Name"
              />

              <Input
                type="text"
                id="lastname"
                name="lastname"
                value={formData.lastname}
                onChange={handleInputChange}
                required
                placeholder="Last Name"
              />

              <Input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="Email"
              />

              {/* <Input
                type="text"
                id="mobile_number"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleInputChange}
                required
                placeholder="Mobile Number"
              /> */}

              <Input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                placeholder="Password"
              />

              <Input
                type="password"
                id="password_confirmation"
                name="password_confirmation"
                value={formData.password_confirmation}
                onChange={handleInputChange}
                required
                placeholder="Confirm Password"
              />

              <div className='my-5 text-left'>
                <p className='text-white'>By signing up, you agree to our <a href="/terms-and-conditions" target="_blank" className='text-custom-light-blue font-semibold'>Terms & Conditions</a>.</p>
              </div>

              <Checkbox
                type="checkbox"
                name="terms"
                label="I agree to the terms and conditions"
                checked={formData.terms}
                onChange={handleInputChange}
                required
              />

              <ButtonLightBlue
                disabled={isRegistering}
                text={isRegistering ? 'Signing up...' : 'Sign Up'} 
              />
          </form>
          <p className='mt-7'>Already have an account? <Link to="/login" className='text-custom-light-blue  font-semibold'>Log In</Link></p>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Register;
